var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"loading":_vm.loading,"size":_vm.size,"type":_vm.type},on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-box-open"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }